import { Card } from "antd";

export const CardBox = ({
  title,
  extra,
  children,
  
  background = "white",
}: any) => {
  return (
    <Card
      className="mainCard"
      title={title}
      extra={extra} 
      style={{ background: background }}
    >
      {children}
    </Card>
  );
};
export default CardBox;